<div class="user-detail">
  <div class="header mt-3 mb-50">
    <div class="d-flex justify-content-between">
      <img
        src="/assets/svg/ico-chevron-back-outline.svg"
        alt="back button"
        class="pointer-cursor"
        *ngIf="stepper > 1"
        (click)="navigateBack()"
      />

      <h1 class="modal-title m-auto">{{ 'DATE_RANGE' | translate }}</h1>

      <ng-content select="[backButton]"></ng-content>
    </div>
  </div>
  <form [formGroup]="formGroup" (ngSubmit)="submit()" novalidate>
    <div>
      <app-date-range-picker
        [(datePicker)]="datePicker"
      ></app-date-range-picker>
    </div>

    <div class="row mt-120">
      <div class="col-12">
        <button class="btn btn-danger px-3 w-100 btn-submit" type="submit">
          {{ 'CONTINUE' | translate }}
        </button>
      </div>
    </div>
  </form>
</div>
